<template>
	<icon-button name="caret-left-12-bold" class="fd-more-opener" :class="{ 'fd-more-open':modelValue, 'fd-more-opener-left': left }" @click="toggleOpen"></icon-button>
</template>

<script setup lang="ts">
import IconButton from "./IconButton.vue";

const props = defineProps({
	modelValue: Boolean,
	// left-hand placement of the opener
	left: Boolean,
});
const emit = defineEmits(["update:modelValue"]);

function toggleOpen() {
	emit("update:modelValue", !props.modelValue);
}
</script>

<style>
.fd-more-opener {
	color: var(--fg);
	cursor: pointer;
	transform: rotate(0);
	transition: transform 300ms, opacity 300ms;
}

.fd-more-opener.fd-more-opener-left {
	transform: rotate(180deg);
}

.fd-more-opener.fd-more-open {
	transform: rotate(-90deg);
}

.fd-more-opener.fd-more-opener-left.fd-more-open {
	transform: rotate(270deg);
}
</style>
